import { createSlice } from "@reduxjs/toolkit";

const initialTraineeDetailsResponse = {
  message: "loading",
  data: [],
};
const initialValues = {
  waveNumber: "",
  taleoReqId: "",
  typeOfRequest: "Activation (New Hire or Reactivation)",
  requestFor: "",
  reqForDateTime: "",
  timeZone: "",
  tCITTDStartDate: "",
  tteTrainingDate: "",
  productionTrainingStart: "",
  productionDate: "",
  siteLocation: "",
  siteLocationName: "",
  currentClientProgram: "",
  newClientProgram: "",
  newClientProgramName: "",
  techDeploymentType: "",
  waveTrainer: "",
  manager: "",
  activeTrainee: "",
  clientCode: "",
  clientName: "",
  noEquipmentRequired: false,
  currentProjectCodes: "",
  newClientCode: "",
  newProgramCode: "",
  newProjectCode: "",
  requestForrOracleId: "",
  waveTrainerOracleId: "",
  managerOracleId: "",
  traineeDetailsResponse: initialTraineeDetailsResponse,
};

const asknowSlice = createSlice({
  name: "idmTicket",
  initialState: initialValues,
  reducers: {
    waveNumber(state, action) {
      state.waveNumber = action.payload ? action.payload : "";
    },
    taleoReqId(state, action) {
      state.taleoReqId = action.payload ? action.payload : "";
    },
    typeOfRequest(state, action) {
      state.typeOfRequest = action.payload ? action.payload : "";
    },
    requestFor(state, action) {
      state.requestFor = action.payload ? action.payload : "";
    },
    requestForrOracleId(state, action) {
      state.requestForrOracleId = action.payload ? action.payload : "";
    },
    reqForDateTime(state, action) {
      state.reqForDateTime = action.payload ? action.payload : "";
    },
    tCITTDStartDate(state, action) {
      state.tCITTDStartDate = action.payload ? action.payload : "";
    },
    tteTrainingDate(state, action) {
      state.tteTrainingDate = action.payload ? action.payload : "";
    },
    productionTrainingStart(state, action) {
      state.productionTrainingStart = action.payload ? action.payload : "";
    },
    productionDate(state, action) {
      state.productionDate = action.payload ? action.payload : "";
    },
    siteLocation(state, action) {
      state.siteLocation = action.payload ? action.payload : "";
    },
    siteLocationName(state, action) {
      state.siteLocationName = action.payload ? action.payload : "";
    },
    currentClientProgram(state, action) {
      state.currentClientProgram = action.payload ? action.payload : "";
    },
    newClientProgram(state, action) {
      state.newClientProgram = action.payload ? action.payload : "";
    },
    newClientProgramName(state, action) {
      state.newClientProgramName = action.payload ? action.payload : "";
    },
    techDeploymentType(state, action) {
      state.techDeploymentType = action.payload ? action.payload : "";
    },
    waveTrainer(state, action) {
      state.waveTrainer = action.payload ? action.payload : "";
    },
    waveTrainerOracleId(state, action) {
      state.waveTrainerOracleId = action.payload ? action.payload : "";
    },
    manager(state, action) {
      state.manager = action.payload ? action.payload : "";
    },
    managerOracleId(state, action) {
      state.managerOracleId = action.payload ? action.payload : "";
    },
    activeTrainee(state, action) {
      state.activeTrainee = action.payload ? action.payload : "";
    },
    timeZone(state, action) {
      state.timeZone = action.payload ? action.payload : "";
    },
    clientCode(state, action) {
      state.clientCode = action.payload ? action.payload : "";
    },
    clientName(state, action) {
      state.clientName = action.payload ? action.payload : "";
    },
    noEquipmentRequired(state, action) {
      state.noEquipmentRequired = action.payload ? action.payload : false;
    },
    currentProjectCodes(state, action) {
      state.currentProjectCodes = action.payload;
    },
    updateNewClientCode(state, action) {
      state.newClientCode = action.payload ? action.payload : "";
    },
    updateNewProgramCode(state, action) {
      state.newProgramCode = action.payload ? action.payload : "";
    },
    updateNewProjectCode(state, action) {
      state.newProjectCode = action.payload ? action.payload : "";
    },
    updateTraineeDetailsResponse(state, action) {
      state.traineeDetailsResponse = action.payload;
    },
    resetTraineeDetailsResponse(state, action) {
      state.traineeDetailsResponse = initialTraineeDetailsResponse;
    },
  },
});

export const askNowActions = asknowSlice.actions;
export default asknowSlice.reducer;
